var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.downloaded)?_c('div',{attrs:{"id":_vm.containerId}}):_c('div',{staticClass:"placeholder"},[_vm._v("Downloading ...")])}
var staticRenderFns = []

export { render, staticRenderFns }